import type { Action } from 'react-sweet-state';

import type { AsyncFields } from '../../../../common/types/async-fields';
import type { AttachmentConfiguration } from '../../../../common/types/attachment';
import type { FieldValidation, Validators } from '../../../../common/types/field-validation';
import type { Form, FormFieldVisibility } from '../../../../common/types/form';
import type { LifecycleHandlers } from '../../../../common/types/lifecycle-handlers';
import type { FormRenderMode } from '../../../../common/types/render-mode';
import type { Renderers } from '../../../../common/types/renderers';
import type { FormRendererState } from '../../types';

export const setFormRendererProps =
	(
		asyncFields: AsyncFields,
		form: Form,
		lifecycleHandlers: LifecycleHandlers,
		renderers: Renderers,
		renderMode: FormRenderMode,
		fieldVisibility: FormFieldVisibility,
		fieldValidation: FieldValidation,
		defaultValidators: Validators,
		attachmentConfiguration?: AttachmentConfiguration,
		securityCriticalValidators?: Validators,
	): Action<FormRendererState> =>
	({ setState, getState }) => {
		setState({
			asyncFields,
			formFields: form.fields,
			formSections: form.sections,
			lifecycleHandlers,
			renderers,
			renderMode,
			fieldVisibility,
			fieldValidation,
			defaultValidators,
			securityCriticalValidators:
				securityCriticalValidators ?? getState().securityCriticalValidators,
			formId: form.id,
			attachmentConfiguration,
		});
	};
